import { render, staticRenderFns } from "./OpenBox.vue?vue&type=template&id=59ccb1d8&scoped=true&"
import script from "./OpenBox.vue?vue&type=script&lang=js&"
export * from "./OpenBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ccb1d8",
  null
  
)

export default component.exports